import { BehaviorType } from "../types";
import Behavior from "../types/Behavior";
import { BEHAVIOR_NEXT_EVENT_DELAY } from "../utils/variables";
class ScrollBehavior extends Behavior {
    constructor(plasm, appName, addMetadata) {
        super(plasm, appName, addMetadata);
        this.oldScrollY = 0;
        this.oldScrollX = 0;
        this.id = BehaviorType.scroll;
        this.oldScrollY = window.scrollY;
        this.oldScrollX = window.scrollY;
        this.handler = (event) => this.onScroll(event);
    }
    onScroll(event) {
        const { scrollY, scrollX } = window;
        if (this.isOnHandler) {
            this.oldScrollY = scrollY;
            this.oldScrollX = scrollX;
            return;
        }
        this.isOnHandler = true;
        let direction = "";
        if (scrollY !== this.oldScrollY) {
            direction = this.oldScrollY < scrollY ? "bottom" : "top";
        }
        else if (scrollX !== this.oldScrollX) {
            direction = this.oldScrollX < scrollX ? "right" : "left";
        }
        this.oldScrollY = scrollY;
        this.oldScrollX = scrollX;
        this.addLog(event, this.id, { direction });
        setTimeout(() => {
            this.isOnHandler = false;
        }, BEHAVIOR_NEXT_EVENT_DELAY);
    }
}
export default ScrollBehavior;
